import React from 'react';

const Sort = () => <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M0 1C0 1.55 0.45 2 1 2H17C17.55 2 18 1.55 18 1C18 0.45 17.55 0 17 0H1C0.45 0 0 0.45 0 1ZM1 12H5C5.55 12 6 11.55 6 11C6 10.45 5.55 10 5 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12ZM11 7H1C0.45 7 0 6.55 0 6C0 5.45 0.45 5 1 5H11C11.55 5 12 5.45 12 6C12 6.55 11.55 7 11 7Z" fill="black"/>
</svg>

export default Sort;
